<div class="trial-banner-component" *ngIf="status === TrialStatus.Active || status === TrialStatus.Expired">
  <mode-calendly-popup-button [userDisplayName]="userDisplayName" [userEmail]="userEmail">
    <!-- @active -->
    <div class="trial-banner-wrapper" *ngIf="status === TrialStatus.Active">
      <span class="trial-number">{{ days }}</span>
      <span class="trial-text">
        <span [ngPlural]="days">
          <ng-template ngPluralCase="=0"> days </ng-template>
          <ng-template ngPluralCase="=1"> day </ng-template>
          <ng-template ngPluralCase="other"> days </ng-template>
          <br />
          remain in your trial
        </span>
      </span>
    </div>
    <!-- @expired -->
    <button class="trial-banner-wrapper" *ngIf="status === TrialStatus.Expired">
      <span class="trial-number trial-number-mobile-only"> 0<span class="trial-dot">&dot;</span> </span>
      <span class="trial-text trial-banner-message-wrap">
        <span class="trial-banner-message"> Your trial has ended </span>
        <br />
        Book a call
      </span>
    </button>
  </mode-calendly-popup-button>
</div>
